import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client'
import { useAsync } from '../hooks/useAsync'
import { t } from '../i18n/lingua'
import { Card, ErrorBanner, Spinner } from './common'

/**
 * Le scelte del tenant sull'assistente «Chiedi a CENSO», per chi amministra:
 * con cosa risponde (la credenziale del modello), quanto ha consumato oggi,
 * la quota di token al giorno e il mascheramento degli indirizzi verso un
 * fornitore esterno. Il modello si configura fra le credenziali («Claude»
 * o «Modello interno»): qui si vede quale è in uso.
 */
export function AssistenteCard() {
  const stato = useAsync(() => api.aiStatus(), [])
  const scelte = useAsync(() => api.aiSettings(), [])
  const [maschera, setMaschera] = useState(false)
  const [quota, setQuota] = useState(300000)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [esito, setEsito] = useState<string | null>(null)

  useEffect(() => {
    if (scelte.data) {
      setMaschera(scelte.data.mask_addresses)
      setQuota(scelte.data.daily_tokens)
    }
  }, [scelte.data])

  async function salva() {
    setBusy(true)
    setError(null)
    setEsito(null)
    try {
      await api.updateAiSettings({ mask_addresses: maschera, daily_tokens: quota })
      setEsito(t('Impostazioni salvate.'))
    } catch (e) {
      setError(e)
    } finally {
      setBusy(false)
    }
  }

  const d = stato.data
  return (
    <Card title={t('Assistente «Chiedi a CENSO»')}>
      <ErrorBanner error={error ?? stato.error ?? scelte.error} />
      {esito && <div className="banner banner--ok">{esito}</div>}
      {!d ? (
        <Spinner />
      ) : (
        <>
          <p>
            {!d.licensed
              ? t('Non compreso nella licenza')
              : d.configured
                ? t('Risponde con «{nome}» ({fornitore}). Oggi ha usato {usati} token su {quota}.', {
                    nome: d.credential_name ?? '',
                    fornitore: d.provider === 'anthropic' ? t('Claude via API') : t('modello interno'),
                    usati: d.used_today_tokens.toLocaleString(),
                    quota: d.quota_daily_tokens.toLocaleString(),
                  })
                : t('Nessun modello configurato: l’assistente risponde utilizzando esclusivamente la ricerca nell’inventario.')}{' '}
            <Link to="/credentials">{t('Credenziali')}</Link>
          </p>
          <p className="text-muted">
            {t('L’assistente può utilizzare Claude (Anthropic) tramite API oppure Modello interno tramite endpoint compatibile OpenAI, anche ospitato nella rete del cliente e raggiungibile tramite sonda. Accede ai dati in sola lettura e nel rispetto delle autorizzazioni dell’utente. Non può modificare configurazioni, eseguire operazioni amministrative o accedere alle credenziali archiviate.')}
          </p>
          <div className="form-grid">
            <label className="field field--inline">
              <input type="checkbox" checked={maschera} onChange={(e) => setMaschera(e.target.checked)} />
              <span>{t('Con modelli esterni, gli indirizzi IP vengono anonimizzati prima dell’elaborazione. Le informazioni originali non lasciano il tenant e vengono ripristinate dal sistema solo al momento della presentazione della risposta.')}</span>
            </label>
            <div className="field">
              <label htmlFor="ai-quota">{t('Quota di token al giorno')}</label>
              <input id="ai-quota" type="number" min={10000} max={50000000} step={10000} value={quota}
                     onChange={(e) => setQuota(Number(e.target.value))} />
            </div>
            <div className="rowactions" style={{ textAlign: 'left' }}>
              <button type="button" onClick={() => void salva()} disabled={busy}>
                {busy ? t('Salvataggio…') : t('Salva')}
              </button>
            </div>
          </div>
        </>
      )}
    </Card>
  )
}
